import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

import ThemeCustomization from 'themes';

// legacy material dashboard context removed

// auth provider

// ==============================|| APP ||============================== //

import GlobalSnackbar from 'components/GlobalSnackbar';

export default function App() {
  return (
    <ThemeCustomization>
        <NavigationScroll>
          <>
            <RouterProvider router={router} />
            <GlobalSnackbar />
          </>
        </NavigationScroll>
    </ThemeCustomization>
  );
}
